import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// img
import delivery from "../food/delivery-man.png"
// components
import Logo from '../components/logo';
import DeleteForm from '../sections/auth/login/DeleteForm';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Delete Your Account </title>

      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              We’re Sad to See You Leave
            </Typography>
            <img src={delivery} alt="login" width={300} />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Delete Your Account
            </Typography>
            <Typography variant="body1" sx={{my: 5}} >
              We are sorry to see you go. Please confirm your request to permanently delete your account and all associated data. This action cannot be undone.
            </Typography>
            <DeleteForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
